import React, { Component } from "react";
import "./Aboutus.css";


export default class Aboutus extends Component {

  renderOld(){
    return(
       <div>
       <div className="container mt-4">

             <br />
             <div className="row cols-xs-space testimonial text-center text-sm-left justify-content-center">
                 <div className="col-md-2 col-sm-4 col-6">
                     <img className="testimonial-image retnet-profile-pic" src="/images/maheshpshanmugam.png" />
                 </div>
                 <div className="col-md-10 col-sm-8 col-10">

                     <div className="testimonial-content">
                         <span className="testimonial-text text-lg strong-300">
                             Dr. Palanivelu Mahesh Shanmugam graduated from Stanley Medical College,
                             Madras in 1990 with a gold medal for proficiency in medicine.
                             He has more than 110 publications in peer-reviewed journals and 15 chapters in
                             textbooks on vitreoretinal disorders, diseases and surgery, ocular oncology. He has
                             co-developed the technique of optimized vacuum control in vitrectomy equipment,
                             which is pending patent approval. <br />
                             He has been awarded the Swarnalatha Punshi award for the Best Research worker
                             by Sankara Nethralaya, Col. Rangachari award by the All India Ophthalmological
                             Society, the Distinguished ophthalmologist Gold Medal by the Uttarakhand
                             ophthalmological society and the Siva Reddy award by the Andhra Pradesh
                             Ophthalmological Society.
                         </span>
                         <h4 className="heading heading-5 strong-600 mt-4 mb-0">Dr. Mahesh P Shanmugam (Founder)</h4>
                         <span className="text-md strong-600">Opthalmic Oncologist</span><br />
                         <span className="text-md strong-600">DO, FRCS ED, PhD, FAICO</span>

                     </div>
                 </div>
             </div>
             <br />
             <hr />
       </div>

       <br />

       <div className="container mt-4">
             <div className="row cols-xs-space testimonial text-center text-sm-left justify-content-center">
                 <div className="col-md-2 col-sm-4 col-6">
                 <div className="profile-picture profile-picture--style-2">
                     <div className="flex flex-column items-center justify-center br1 ba bw2 b--white shadow-2 pa3 bg-gray2">
                           <svg aria-hidden="true" data-prefix="fas"
                               data-icon="user" role="img"
                               xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 448 512"
                                className="svg-inline--fa fa-user fa-w- fa-2x">

                                <path fill="currentColor"
                                   d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z" >
                                </path>
                           </svg>
                     </div>
                 </div>
                 </div>
                 <div className="col-md-10 col-sm-8 col-10">
                     <br />
                     <div className="testimonial-content">
                         <span className="testimonial-text text-lg strong-300">
                             Dr. Rajesh R is a consultant in Shankar Netralaya hospital, Bangalore. He specialises in Vitreo Retina &
                             Ocular Oncology.
                         </span>
                         <h4 className="heading heading-5 strong-600 mt-4 mb-0">Dr. Rajesh R (Co-Founder)</h4>
                         <span className="text-md strong-600">Vitreo Retina & Ocular Oncology</span><br />
                         <span className="text-md strong-600">DO, FRCS ED, PhD, FAICO</span>

                     </div>
                 </div>
             </div>
             <br />
             <hr />
       </div>
       <br />

       <div className="container mt-4">
             <div className="row cols-xs-space testimonial text-center text-sm-left justify-content-center">
                 <div className="col-md-2 col-sm-4 col-6">
                     <img className="testimonial-image retnet-profile-pic" src="/images/divyanshmishra.png" />
                 </div>
                 <div className="col-md-10 col-sm-8 col-10">

                     <div className="testimonial-content">
                         <span className="testimonial-text text-lg strong-300">
                             Dr. Divyansh Mishra is a Vitreo Retina & Ocular Oncolofy Surgeon at Shankar Netralaya
                             Hosptital, Marathahalli, Bangalore. He is one of the Co-Founder of Retnet India.

                         </span>
                         <h4 className="heading heading-5 strong-600 mt-4 mb-0">Dr. Divyansh Mishra (Co-Founder)</h4>
                         <span className="text-md strong-600">Vitreo Retina & Ocular Oncology</span><br />
                         <span className="text-md strong-600">DOMS, DNB, FVRS, ICO, FAICO, FGO, FMR</span>

                     </div>
                 </div>
             </div>
             <br />

       </div>

       <br />

       </div>

    );
  }

  render() {

      return (
          <div>

          <div className="container-fluid">
          <section className="cta-wrapper">

                <div className="slice cta-inner bg-base-1">
                    <div className="flex flex-items-xs-middle">
                        <div className="flex-wrap-item">
                            <div className="sct-inner ">
                                <div className="container">
                                    <div className="text-center retnet-yrsa-font">
                                        <h1 className="heading heading-2 text-normal c-base-text-1 strong-400">
                                            OUR PHILOSOPHY
                                        </h1>
                                        <br />
                                        <h4>"Katradhu Kai Mann Alavu; Kalladadhu Ulagaluvu" (--Avvaiyar)</h4>
                                        <br />
                                        <h4>"What we know is a mere
                                        handful; What we donot know is as big as the universe" </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

          </section>

                <section class="slice-lg pt-0 ">
                      <div class="container">
                          <div class="row cols-xs-space cols-sm-space align-items-center">
                              <div class="col-md-6 ml-lg-auto order-md-2">
                                  <div class="block block-image-holder z-depth-3">
                                      <div class="block-image">
                                          <img src="/images/2018/2.JPG" class="img-responsive img-center image-with-border" />
                                      </div>
                                  </div>
                              </div>

                              <div class="col-md-6 col-lg-5 order-md-1 mt-4">
                                  <div class="col-lg-space-right">
                                      <h3 class="heading heading-2 strong-500 text-center">

                                      </h3>
                                      <p class="line-height-1_8 c-gray-light mt-4 retnet-home-desc retnet-18-font-size" >
                                          RetNet India is a Network of Retina Specialists in India who
                                          help each other learn, hone their clinical and surgical skills for the
                                          greater benefit of patients and the field of Vitreoretinal Diseases & Surgery.

                                      </p>

                                      <p class="line-height-1_8 c-gray-light retnet-home-desc  retnet-18-font-size" >
                                          RetNet meetings are unique in nature as there are no didactic lectures,
                                          but only have case based discussions. In RETNET INDIA MEET-2018 we had
                                          enhanced the surgical session - "Fellows Follies", a basic section
                                          that comprised of beginners mistakes and a more advanced "Consultant Conundrums" section.
                                      </p>

                                      <p class="line-height-1_8 c-gray-light  retnet-home-desc  retnet-18-font-size" >
                                          We have been together for past 10 years, and the meetings getting better with each year.
                                          Thanks to the great cases that all of you brought in. Hope we can join hands
                                          to make it better every year.
                                      </p>

                                  </div>
                              </div>
                          </div>

                          <span class="space-xs-xl"></span>


                      </div>
                  </section>



          </div>

              <div className="container-fluid retnet-no-padding">
                  <section className="cta-wrapper">
                            <a href="https://goo.gl/9BbH7R" target="_blank">
                                <div className="slice cta-inner bg-base-1">
                                    <div className="flex flex-items-xs-middle">
                                        <div className="flex-wrap-item">
                                            <div className="sct-inner ">
                                                <div className="container">
                                                    <div className="text-center">
                                                        <h1 className="heading heading-3 text-normal c-base-text-1 strong-400">
                                                            <br />
                                                            OUR VISIONARIES
                                                            <br />
                                                            <br />
                                                        </h1>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </a>
                    </section>
              </div>
              <br />

              <br />
              <br />

              <div className="container">
                  <div className="row">
                    <div className="retnet-team retnet-center-text">

                          <img src="./images/maheshpshanmugam.png" className="retnet-team-img"/>
                          <div className="heading heading-6 strong-600 mb-0">Dr. Mahesh P Shanmugam</div>
                          <div className="heading heading-6 strong-600 mb-0 retnet-blue">President</div>
                          <br />
                          <div className="heading heading-6 strong-400 mb-0">
                              Head of Vitreoretinal and Ocular Oncology Services<br/><br />
                              Sankara Eye Hospitals
                          </div>
                          <br />


                    </div>
                    <div className="retnet-team retnet-center-text">

                          <img src="./images/avinash.jpg" className="retnet-team-img"/>
                          <div className="heading heading-6 strong-600 mb-0">Dr. Avinash Pathengay</div>
                          <div className="heading heading-6 strong-600 mb-0 retnet-blue">Vice President</div>
                          <br />
                          <div className="heading heading-6 strong-400 mb-0">
                                Director, Academy for Eye Care Education <br  /><br />
                                LV Prasad Eye Institute <br />
                          </div>


                    </div>
                    <div className="retnet-team retnet-center-text">

                          <img src="./images/manishagarwal.jpg" className="retnet-team-img"/>
                          <div className="heading heading-6 strong-600 mb-0">Dr. Manisha Agarwal</div>
                          <div className="heading heading-6 strong-600 mb-0 retnet-blue">Secretary</div>
                          <br />
                          <div className="heading heading-6 strong-400 mb-0">

                          </div>


                    </div>
                 </div>

                 <br/>
                 <br />
                 <br />

                 <div className="row">
                   <div className="retnet-team retnet-center-text">

                         <img src="./images/RajeevJain.JPG" className="retnet-team-img"/>
                         <div className="heading heading-6 strong-600 mb-0">Dr. Rajeev Jain</div>
                         <div className="heading heading-6 strong-600 mb-0 retnet-blue">Treasurer</div>
                         <br />
                         <div className="heading heading-6 strong-400 mb-0">

                         </div>
                         <br />


                   </div>
                   <div className="retnet-team retnet-center-text">

                         <img src="./images/DrRajesh.jpg" className="retnet-team-img"/>
                         <div className="heading heading-6 strong-600 mb-0">Dr. Rajesh Ramanjulu</div>
                         <div className="heading heading-6 strong-600 mb-0 retnet-blue">E.C. Member</div>
                         <br />
                         <div className="heading heading-6 strong-400 mb-0">

                         </div>


                   </div>
                   <div className="retnet-team retnet-center-text">

                         <img src="./images/hemanttrehan.png" className="retnet-team-img"/>
                         <div className="heading heading-6 strong-600 mb-0">Dr. Hemant Trehan</div>
                         <div className="heading heading-6 strong-600 mb-0 retnet-blue">E.C. Member</div>
                         <br />
                         <div className="heading heading-6 strong-400 mb-0">

                         </div>


                   </div>
                </div>

                <br/>
                <br />
                <br />

                <div className="row center">
                  <div className="retnet-team-noborder retnet-center-text">
                  </div>

                  <div className="retnet-team retnet-center-text">

                        <img src="./images/divyanshmishra.png" className="retnet-team-img"/>
                        <div className="heading heading-6 strong-600 mb-0">Dr. Divyansh Mishra</div>
                        <div className="heading heading-6 strong-600 mb-0 retnet-blue">E.C. Member</div>
                        <br />
                        <div className="heading heading-6 strong-400 mb-0">

                        </div>


                  </div>

                  <div className="retnet-team-noborder retnet-center-text">
                  </div>

               </div>
              </div>


            

              <br/>
              <br />


          </div>
      );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Aboutus.js